"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _MuiTheme = _interopRequireDefault(require("./MuiTheme.json"));
var _material = require("@heron-web/material");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = (0, _styles.createMuiTheme)((0, _lodash.default)(_material.Theme, _MuiTheme.default));
exports.default = _default;